'use strict';

var novicell = novicell || {};
novicell.helpers = novicell.helpers || function () {
    var olay = "";
    function addListenerMulti(el, s, fn){
        s.split(' ').forEach(

            function (e) {
                el.addEventListener(e, fn, false);
            }
        );
    }
    function closestByClass (el, clazz) {
        // Traverse the DOM up with a while loop
        while (el.classList == undefined || !el.classList.contains(clazz)) {
            // Increment the loop to the parent node
            el = el.parentNode;
            if (!el ) {
                return null;
            }
        }
        // At this point, the while loop has stopped and `el` represents the element that has
        // the class you specified in the second parameter of the function `clazz`
    
        // Then return the matched element
        return el;
    }

    function prepend(outerTag, elementToPrepend) { 
        outerTag.insertBefore(elementToPrepend ,outerTag.children[0]); 
    }

    function addCSSRule(sheet, selector, rules, index) {
        if("insertRule" in sheet) {
            sheet.insertRule(selector + "{" + rules + "}", index);
        }
        else if("addRule" in sheet) {
            sheet.addRule(selector, rules, index);
        }
    }

    function whichTransitionEvent(){
        var t;
        var el = document.createElement('fakeelement');
        var transitions = {
            'transition':'transitionend',
            'OTransition':'oTransitionEnd',
            'MozTransition':'transitionend',
            'WebkitTransition':'webkitTransitionEnd'
        };
        for(t in transitions){
            if( el.style[t] !== undefined ){
                return transitions[t];
            }
        }
    }

    function getAllUrlParams(url){
        // get query string from url (optional) or window
        var queryString = url ? url.split('?')[1] : window.location.search.slice(1);

        // we'll store the parameters here
        var obj = {};

        // if query string exists
        if (queryString) {

            // stuff after # is not part of query string, so get rid of it
            queryString = queryString.split('#')[0];

            // split our query string into its component parts
            var arr = queryString.split('&');

            for (var i=0; i<arr.length; i++) {
                // separate the keys and the values
                var a = arr[i].split('=');

                // in case params look like: list[]=thing1&list[]=thing2
                var paramNum = undefined;
                var paramName = a[0].replace(/\[\d*\]/, function(v) {
                    paramNum = v.slice(1,-1);
                    return '';
                });

                // set parameter value (use 'true' if empty)
                var paramValue = typeof(a[1])==='undefined' ? true : a[1];

                // (optional) keep case consistent
                paramName = paramName.toLowerCase();
                paramValue = paramValue.toLowerCase();

                // if parameter name already exists
                if (obj[paramName]) {
                    // convert value to array (if still string)
                    if (typeof obj[paramName] === 'string') {
                        obj[paramName] = [obj[paramName]];
                    }
                    // if no array index number specified...
                    if (typeof paramNum === 'undefined') {
                        // put the value on the end of the array
                        obj[paramName].push(paramValue);
                    }
                    // if array index number specified...
                    else {
                        // put the value at that index number
                        obj[paramName][paramNum] = paramValue;
                    }
                }
                // if param name doesn't exist yet, set it
                else {
                    obj[paramName] = paramValue;
                }
            }
        }
        return obj;
    }


    function animate(elem, style, unit, from, to, duration, isProp) {
        if (!elem) {
            return;
        }
        var start = new Date().getTime(),
            timer = setInterval(function () {
                var step = Math.min(1, (new Date().getTime() - start) / duration);
                if (isProp) {
                    elem[style] = (from + step * (to - from))+unit;
                } else {
                    elem.style[style] = (from + step * (to - from))+unit;
                }
                if (step === 1) {
                    clearInterval(timer);
                }
            }, 25);
        if (isProp) {
            elem[style] = from+unit;
        } else {
            elem.style[style] = from+unit;
        }
    }

    function closeOverlay(elem, event) {
        event.preventDefault();
        if (elem) {
            var parent = elem.closest(".novi-backdrop");
            if (parent) {
                parent.style.display = "none";
            }
        }
    }

    function openOverlay(selector, event) {
        event.preventDefault();
        if (selector) {
            var overlayElem = document.querySelector(selector);
            if (overlayElem) {
                overlayElem.style.display = "block";
            }
        }
    }
    

    return {
        addListenerMulti:addListenerMulti,
        closestByClass:closestByClass,
        prepend:prepend,
        whichTransitionEvent:whichTransitionEvent,
        animate:animate,
        getAllUrlParams:getAllUrlParams,
        closeOverlay: closeOverlay,
        openOverlay: openOverlay
    };
}();
